module.exports = __webpack_public_path__ + "assets/img/follow_read.25dfb0fe.png";